export const images = ['bmp', 'gif', 'ico', 'jpeg', 'jpg', 'png'];

export const audio = ['weba', 'mp3', 'ogg', 'wav', 'm4a', 'flac'];

export const pdf = 'pdf';

export const MAX_DOCUMENT_SIZE = 25 * 1024 * 1024; // 25MB
